<div class="more-menu-trigger row d-flex justify-content-end pr-3 pl-3" #dotsMenu>
    <span (click)="menuClicked()"><i class="icon-show-more"></i></span>
    <div class="more-menu" *ngIf="isClicked">
        <ul>
            <li *ngFor="let element of menuElements" (click)="onItemClicked(element)">
                <span><i [class]="element.icon"></i></span>
                {{element.content}}
            </li>
        </ul>
    </div>
</div>